<template>
    <div>
        <h5>Change Password</h5>
        <div class='alert alert-success' v-show='success'>Password changed successfully!</div>
        <div class='row'>
            <input type='password' class='form-control col-md-4 offset-md-4 my-2' v-model='oldPassword' :disabled='success' placeholder='Old Password'/>
            <input type='password' class='form-control col-md-4 offset-md-4 my-2' v-model='newPassword' :disabled='success' placeholder='New Password'/>
            <input type='password' class='form-control col-md-4 offset-md-4 my-2' v-model='confirmPassword' :disabled='success' placeholder='Confirm Password'/>
            <div class='col-md-4 offset-md-4 my-2'>
                <ul style='color:red;'>
                    <li v-for='error in errors'>{{error}}</li>
                </ul>
            </div>
            <div class='col-md-4 offset-md-4 mt-5'><button class='btn btn-primary' :disabled='success || submitting' v-on:click='submit'>
                <span v-show='!submitting'>Submit</span>
                <span v-show='submitting'>Please wait...</span>
            </button></div>
        </div>
    </div>
</template>

<script>
import http from "../commons/http.js";
import auth from "../commons/auth.js";
export default {
    data:function(){
        return{
            newPassword:'',
            oldPassword:'',
            confirmPassword:'',
            submitting:false,
            success:false,
            errors:[]
        }
    },
    methods:{
        submit:async function(){
            if(this.validate() > 0){
                return;
            }
            this.submitting = true;

            // Get username
            let username = '';
            try{
                let response = await auth.post('/verify', {token:http.getToken()});
                username = response.data.username;
            }catch(err){
                console.error('auth verify err', err);
            }
            // Change Password
            try{
                let data = {
                    username:username,
                    oldPassword:this.oldPassword,
                    newPassword:this.newPassword
                };
                let response = await auth.post('/passwordchange', data);
                this.success = true;
            }catch(err){
                console.error('change password err', err);
            }

            this.submitting = false;
        },

        validate: function(){
            this.errors = [];

            if(this.oldPassword.trim().length === 0){
                this.errors.push("Old password is required");
            }

            if(this.newPassword.trim().length === 0){
                this.errors.push("New password is required");
            }

            if(this.confirmPassword.trim().length === 0){
                this.errors.push("Confirm password is required");
            }

            if(this.newPassword !== this.confirmPassword){
                this.errors.push("New password and confirm password does not match.");
            }
            return this.errors.length;
        }
    },
    beforeMount: async function() {
    if (!(await http.isLoggedIn())) {
      this.$router.push("/adminlogin");
    }
  }
}
</script>

<style>

</style>
